import {AfterViewInit, Directive, ElementRef} from '@angular/core';

// tslint:disable-next-line:directive-selector
@Directive({ selector: '[scrollTo]'})
export class ScrollToDirective implements AfterViewInit {

    constructor(private elementRef: ElementRef) {}

    ngAfterViewInit(): void {
        setTimeout(_args => this.elementRef.nativeElement.scrollIntoView({behavior: 'smooth', block: 'center'}), 100);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/directives/scroll-to.directive.ts